import { jsx } from 'panel';
import { delayedAttrRemove } from 'panel/build/component-utils/hook-helpers';
import { SvgIconEl } from 'common/components/svg-icon';
import { TooltipEl } from 'common/components/tooltip';
import { ContextPanelEl } from 'common/widgets/context-panel';
import { ButtonEl } from 'common/components/button';
import { DropMenuEl } from 'common/components/drop-menu';
import { InputEl } from 'common/components/input';
import { ItemsMenuEl } from 'common/components/items-menu';
import { Placement } from 'common/components/tooltip/types';
import { ButtonTheme } from 'common/components/button/constants';

const Label = _ref => {
  let {
    includeLeftIcon,
    includeRightIcon,
    hasSelectedLabel,
    selectLabel,
    leftIcon,
    rightIcon,
    hasSlot
  } = _ref;
  const hasButtonSuffixSlot = hasSlot;
  return jsx("div", {
    sel: '.select-label-wrapper'
  }, leftIcon && includeLeftIcon ? jsx(SvgIconEl, {
    sel: '.left-icon',
    attrs: {
      elref: "leftIcon",
      icon: leftIcon
    },
    class: {
      'select-has-label': hasSelectedLabel
    }
  }) : null, hasSelectedLabel ? jsx("div", {
    sel: '.select-label',
    attrs: {
      elref: "label"
    }
  }, selectLabel) : null, hasButtonSuffixSlot ? jsx("slot", {
    attrs: {
      name: "button-suffix"
    }
  }) : null, rightIcon && includeRightIcon ? jsx(SvgIconEl, {
    sel: '.right-icon',
    attrs: {
      elref: "rightIcon",
      icon: rightIcon
    },
    class: {
      'select-has-label': hasSelectedLabel
    }
  }) : null);
};

export function SelectTriggerButton(_ref2) {
  let {
    selectCmp
  } = _ref2;
  const hasTriggerSlot = selectCmp.helpers.hasSlot("trigger");
  const {
    contextPanelTransform,
    isOpen
  } = selectCmp.state;
  const showHoverContextPanel = contextPanelTransform && !hasTriggerSlot;
  const theme = selectCmp.helpers.getTriggerButtonTheme();
  const hasSelectedLabel = selectCmp.helpers.hasSelectedLabel();
  const selectLabel = selectCmp.helpers.selectedLabel();
  const {
    leftIcon,
    rightIcon
  } = selectCmp.helpers.getIcon();
  const hasSlot = selectCmp.helpers.hasSlot("button-suffix");
  return jsx("div", {
    sel: '.select-trigger',
    attrs: {
      elref: "trigger"
    },
    class: {
      'has-trigger-slot': hasTriggerSlot
    },
    on: {
      click: selectCmp.attr("disabled") || selectCmp.attr("readonly") ? null : () => selectCmp.setDropMenuIsOpen(!isOpen),
      mouseenter: showHoverContextPanel && selectCmp.helpers.handleTriggerMouseEnter,
      mouseleave: showHoverContextPanel && selectCmp.helpers.handleTriggerMouseLeave
    }
  }, selectCmp.helpers.isButtonSelect() ? jsx(ButtonEl, {
    class: {
      truncated: !selectCmp.attr("no-button-truncate")
    },
    attrs: Object.assign({
      theme,
      size: selectCmp.attr("size"),
      disabled: selectCmp.attr("disabled"),
      readonly: selectCmp.attr("readonly"),
      'not-focusable': true,
      pressed: isOpen
    }, leftIcon ? {
      icon: leftIcon
    } : {})
  }, !selectCmp.attr("icon-only") || selectCmp.attr("show-icon-only-down-caret") ? jsx(Label, {
    includeLeftIcon: false,
    includeRightIcon: selectCmp.helpers.shouldShowRightIcon(),
    hasSelectedLabel: hasSelectedLabel,
    selectLabel: selectLabel,
    leftIcon: leftIcon,
    rightIcon: rightIcon,
    hasSlot: hasSlot
  }) : null) : hasTriggerSlot ? jsx("slot", {
    attrs: {
      name: "trigger"
    }
  }) : jsx(Label, {
    includeLeftIcon: true,
    includeRightIcon: false,
    hasSelectedLabel: hasSelectedLabel,
    selectLabel: selectLabel,
    leftIcon: leftIcon,
    rightIcon: rightIcon,
    hasSlot: hasSlot
  }));
}
export function template() {
  const {
    contextPanelTransform,
    isOpen,
    searchFilter,
    sectionsFromInputFn,
    tooltipData
  } = this.state;
  const hasTriggerSlot = this.helpers.hasSlot("trigger");
  const hasBodySlot = this.helpers.hasSlot("body");
  const hasFooterSlot = this.helpers.hasSlot("footer");
  const tooltip = this.helpers.getTooltip();
  const showHoverContextPanel = contextPanelTransform && !hasTriggerSlot;
  return jsx("div", {
    sel: '.select-container',
    class: {
      'has-trigger-slot': hasTriggerSlot
    }
  }, !isOpen && tooltip ? jsx(TooltipEl, {
    attrs: Object.assign(Object.assign({
      placement: Placement.Top,
      'always-show': false
    }, tooltip), {
      'body-level': true
    })
  }) : null, !isOpen && showHoverContextPanel && tooltipData ? jsx(ContextPanelEl, {
    attrs: {
      elref: "hoverContextPanel",
      'tooltip-data': JSON.stringify(tooltipData),
      'position-parent-selector': ".select-container",
      placement: "bottom"
    },
    on: {
      hoverIn: this.helpers.handleContextPanelHoverIn,
      hoverOut: this.helpers.handleContextPanelHoverOut
    },
    hook: {
      remove: delayedAttrRemove("tooltip-data", null)
    }
  }) : null, jsx(SelectTriggerButton, {
    selectCmp: this
  }), isOpen ? (() => {
    const isSearchable = this.helpers.isSearchable();
    const menuWidth = this.helpers.getDropMenuWidth(isSearchable);
    const menuHeight = this.helpers.getDropMenuHeight();
    return jsx("div", {
      sel: '.select-drop-menu'
    }, jsx(DropMenuEl, {
      attrs: {
        'caret-pos': this.attr("caret-pos"),
        open: isOpen,
        'with-caret': Boolean(this.attr("caret-pos")),
        'prevent-close-selectors': [".select-trigger", "#chmln-dom"],
        'use-fixed-pos': this.attr("use-fixed-dropmenu-pos"),
        responsive: true
      },
      props: {
        boundaryEl: this.helpers.getBoundaryEl()
      },
      on: {
        change: ev => this.helpers.handleDropMenuChange(ev)
      },
      hook: {
        insert: this.helpers.handleDropMenuInsert
      }
    }, hasBodySlot ? jsx("slot", {
      attrs: {
        name: "body"
      }
    }) : jsx(null, null, this.attr("header-title") ? jsx("div", {
      sel: '.header-title',
      style: {
        width: "".concat(menuWidth, "px")
      }
    }, this.attr("back-button") ? jsx(ButtonEl, {
      sel: '.back-button',
      attrs: {
        theme: ButtonTheme.Tertiary,
        icon: "caret-left",
        title: "Back (\u21E6 Left Arrow)"
      },
      on: {
        click: this.helpers.handleBackClick
      }
    }) : null, jsx("div", {
      sel: '.title-text'
    }, this.attr("header-title"))) : null, isSearchable ? jsx(InputEl, {
      key: this.attr("header-title"),
      style: {
        width: "".concat(menuWidth, "px")
      },
      attrs: {
        'hide-focus-styling': this.attr("hide-input-focus-styling"),
        elref: "searchInput",
        icon: "search",
        placeholder: this.attr("search-placeholder"),
        'show-clear': true,
        tabindex: 0
      },
      props: {
        value: searchFilter
      },
      on: {
        clear: () => this.helpers.handleSearchInput(""),
        input: ev => this.helpers.handleSearchInput(ev.target.value)
      },
      hook: {
        insert: this.helpers.handleSearchInputInsert,
        destroy: () => this.focus()
      }
    }) : null, jsx(ItemsMenuEl, {
      key: this.attr("header-title"),
      style: {
        width: "".concat(menuWidth, "px"),
        'max-height': "".concat(menuHeight, "px")
      },
      attrs: {
        multiple: this.attr("multiple"),
        'show-select-all': this.attr("show-select-all"),
        'search-filter': searchFilter,
        'empty-message': this.attr("empty-message"),
        'align-all-text': this.attr("align-all-text")
      },
      props: {
        sections: this.helpers.getItemsMenuSections(),
        sectionsFromInputFn,
        keydownProxyEl: this,
        contextPanelTransform: this.helpers.itemContextPanelTransform()
      },
      on: {
        clickItem: this.helpers.handleClickItem,
        focusItem: this.helpers.handleFocusItem,
        selectAll: this.helpers.handleSelectAll
      }
    })), hasFooterSlot ? jsx("div", {
      sel: '.select-footer'
    }, jsx("slot", {
      attrs: {
        name: "footer"
      }
    })) : null));
  })() : null);
}